<template>

  <div>

    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 content-marker">
      <span class="text-1-8 tw-font-bold"> {{ dateEvent.adresse }}</span>
      <span class="text-1-8 tw-font-bold tw-mb-4">
        {{ dateEvent.codePostal }} - {{ dateEvent.ville }}
      </span>
    </div>
  </div>
</template>

<script>
import store from "../../store";

export default {
  name: "MarkerPopupAdresse",
  props: ['contenu'],
  computed : {
    dateEvent() {
      if(store.state.currentEvent) return store.state.currentEvent
      return this.contenu.acfEvent.dates[0]
    }
  }
}
</script>

<style lang="scss">

</style>
